import { ActionsMenuAction } from "../../../common/actions-menu/ActionsMenu";
import { Edit, Delete, Pin } from "@sweep-io/sweep-design/dist/icons";

export type CategoryMenuAction = 'pin' | 'edit' | 'delete';


export const getCategoryMenuActions = (isPinned: boolean): ActionsMenuAction<CategoryMenuAction>[] => [
    {
      label: isPinned ? 'Unpin Category' : 'Pin Category',
      value: 'pin',
      actionIcon: <Pin size="medium" />,
      addBottomDivider: true,
    },
    {
      label: 'Edit Category',
      value: 'edit',
      actionIcon: <Edit size="medium" />,
    },
    {
      actionIcon: <Delete size="medium" />,
      label: 'Delete Category',
      value: 'delete',
    },
  ];